import { render, staticRenderFns } from "./SeedModal.vue?vue&type=template&id=af673c56&scoped=true&"
import script from "./SeedModal.vue?vue&type=script&lang=js&"
export * from "./SeedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af673c56",
  null
  
)

export default component.exports